import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentStatus = createSelector(
  [(store: RootState) => store.documentShow.document.status],
  (data) => data
);
